import TextField from '@mui/material/TextField';
import { useEffect, useState, useRef } from 'react'; 

const TableInput = ({ tag, objKey, list, setList, count, length, width, font, showError, nullifyEmpty, overrideBlank}) =>{
    // initialize state
    const [value, setValue] = useState(''); 
    // initialize ref
    const ref = useRef();
    
    // set width if not given as prop
    if (width == null){
        width = '16.6vw';
    }

    // set font size if given as prop, else use default
    let style = {};
    if (font){
        style['fontSize'] = font;
    } 

    // return null if empty string
    const nullIfEmpty = ( str ) => {
        if (str != null && str.length == 0){
            return null; 
        }
        else {
            return str; 
        }
    }

    // handle change event to input 
    const onChange = (val) => { 
        // set value for text box
        setValue(value => value = val); 
        // set state list obj
        if ((overrideBlank == true || list[count]['blank'] == false) && nullifyEmpty){
            let temp = list; 
            temp[count][objKey] = nullIfEmpty(val); 
            setList(list => list = temp );
            console.log(temp); 
        }
        else if (overrideBlank == true || list[count]['blank'] == false) {
            let temp = list; 
            temp[count][objKey] = val; 
            setList(list => list = temp );
            console.log(temp); 
        }
    }

    // handle showing error and setting focus
    const [error, setError] = useState(); 
    useEffect(() => {
        if (showError && showError == true) { 
            // set show error
            setError(error => error = true); 
            // focus on error element 
            ref.current.focus();
        }
        else {
            setError(error => error = false); 
        }
    }, [showError]); 

    // use state for length change 
    useEffect(() => {
        setValue(value => value = list[count][objKey]); 
    }, [length]); 

    return (
        <>
            {/* material ui textfield for text input */}
            <TextField 
                value = {value}
                sx={{ width: width, maxWidth: 450 }} 
                id="outlined-basic" 
                size='small' 
                label={tag} 
                variant="outlined" 
                onChange={(e)=>onChange(e.target.value)}
                inputProps={{style: style}} // font size of input text
                InputLabelProps={{style: style}} // font size of input label
                error={error}
                inputRef={ref}
            />
        </> 
    );
} 

export default TableInput;